import { FC, memo } from 'react';
import { Menu as ChakraMenu, Portal } from '@chakra-ui/react';

import { MenuProps } from './types/MenuProps';

const MenuComponent: FC<MenuProps> = ({
  children,
  placement = 'bottom-start',
  menuContent,
  ...props
}) => (
  <ChakraMenu.Root positioning={{ placement }} {...props}>
    <ChakraMenu.Trigger asChild>{children}</ChakraMenu.Trigger>
    <Portal>
      <ChakraMenu.Positioner>
        <ChakraMenu.Content>{menuContent}</ChakraMenu.Content>
      </ChakraMenu.Positioner>
    </Portal>
  </ChakraMenu.Root>
);

export const Menu = memo(MenuComponent);
